module.exports = __webpack_public_path__ + "static/media/key_.cac5edcf.png";